<template>
  <SearchBox
    v-model="fulltext"
    :label="$t('text-search-label')"
    name="catalogue-search"
    variant="minimal"
    :placeholder="$t('common:text-search-placeholder-section', { name: $t('nav-menu-catalogue') })"
    :on-submit="submit"
    :on-clear-search="clear"
    :submit-on-change="false"
  />
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import { useUIStore } from '@stores/ui';
import SearchBox from "@components/ui/search-box";

const route = useRoute();
const ui = useUIStore();
const { $eventBus } = useNuxtApp();

const fulltext = ref(route.query?.fulltext || '');

const routeName = computed(() => route?.name || '');
const isCataloguePage = computed(() => routeName.value.startsWith('catalogue___') || routeName.value.startsWith('catalogue-type-slug___'));

const apply = _.debounce(async (value) => {
  await useSearchParam('fulltext', value);
}, 500, { leading: false, trailing: true });

watch(fulltext, (value) => apply(value));

watch(() => route.query?.fulltext, (value) => {
  if ((value || '') !== fulltext.value) {
    fulltext.value = value || '';
  }
});

const submit = async () => {
  apply.cancel();

  if (ui.displaySidebar) {
    $eventBus.emit('sidebar:close');
  }

  if (isCataloguePage.value) {
    await useSearchParam('fulltext', fulltext.value);
    return;
  }

  const query = { ...route.query };
  if (_.isEmpty(fulltext.value)) {
    delete query.fulltext;
  } else {
    query.fulltext = fulltext.value;
  }

  await navigatorTo({ path: translatePath(ROUTES.CODE.SEARCH), query });
};

const clear = async () => {
  apply.cancel();
  fulltext.value = '';
  await useSearchParam('fulltext', '');
};

</script>
